module.exports = __webpack_public_path__ + "static/media/crix_main_logo.6fd1f997.png";